import React, { useState } from "react";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Form, FloatingLabel } from "react-bootstrap";
import AlertModal from "../../components/AlertModal";
import { HospitalService } from "../../services/HospitalService";

function AddHospital(props) {
  const [formData, setFormData] = useState({
    hospitalName: "",
    contactPersonName: "",
    contactNumber: "",
    optionalContactNumber: "",
    emailId: ""
  });
  const [loading, setLoading] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddHospital = async () => {
    // Basic validation
    if (!formData.hospitalName || !formData.contactPersonName || !formData.contactNumber || !formData.emailId) {
      setModalData({
        title: "Validation Error",
        message: "Please fill in all required fields",
        variant: "error"
      });
      setShowAlertModal(true);
      return;
    }

    setLoading(true);
    try {
      const res = await HospitalService.addHospital(formData);
      if (res.status === 200) {
        setModalData({
          title: "Success",
          message: res.message || "Hospital added successfully!",
          variant: "success"
        });
        setShowAlertModal(true);
        // Reset form
        setFormData({
          hospitalName: "",
          contactPersonName: "",
          contactNumber: "",
          optionalContactNumber: "",
          emailId: ""
        });
        props.onHide(); // Close modal
        if (props.onClose) props.onClose(); // Refresh parent list
      } else {
        setModalData({
          title: "Error",
          message: "Error while adding hospital",
          variant: "error"
        });
        setShowAlertModal(true);
      }
    } catch (error) {
      setModalData({
        title: "Error",
        message: error.message || "Failed to add hospital",
        variant: "error"
      });
      setShowAlertModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Hospital
          </Modal.Title>
        </Modal.Header>
        <div className="input-modal-spacing">
          <Row>
            <Col>
              <FloatingLabel
                controlId="hospital"
                label="Hospital*"
                className="mb-3"
              >
                <Form.Control 
                  type="text" 
                  placeholder="Hospital*" 
                  name="hospitalName"
                  value={formData.hospitalName}
                  onChange={handleInputChange}
                />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel
                controlId="contactName"
                label="Contact Person Name*"
                className="mb-3"
              >
                <Form.Control 
                  type="text" 
                  placeholder="Contact Person Name*" 
                  name="contactPersonName"
                  value={formData.contactPersonName}
                  onChange={handleInputChange}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <FloatingLabel
                controlId="hospitalContact"
                label="Hospital Contact no*"
                className="mb-3"
              >
                <Form.Control 
                  type="text" 
                  placeholder="Hospital Contact no*" 
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleInputChange}
                />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel
                controlId="optionalContact"
                label="Optional Contact no"
                className="mb-3"
              >
                <Form.Control 
                  type="text" 
                  placeholder="Optional Contact no" 
                  name="optionalContactNumber"
                  value={formData.optionalContactNumber}
                  onChange={handleInputChange}
                />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="email" label="Email*" className="mb-3">
                <Form.Control 
                  type="email" 
                  placeholder="Email*" 
                  name="emailId"
                  value={formData.emailId}
                  onChange={handleInputChange}
                />
              </FloatingLabel>
            </Col>
          </Row>
        </div>
        <hr className="color-grey" />
        <Row className="modal-button-group-spacing">
          <Col className="modal-add-button-spacing">
            <Button onClick={handleAddHospital} disabled={loading}>
              {loading ? "Adding..." : "Add"}
            </Button>
          </Col>
          <Col className="modal-cancel-button-spacing">
            <Button onClick={props.onHide} variant="dark">
              Cancel
            </Button>
          </Col>
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
        </Row>
      </Modal>
      
      <AlertModal
        show={showAlertModal}
        onHide={() => setShowAlertModal(false)}
        title={modalData.title}
        message={modalData.message}
        variant={modalData.variant}
      />
    </>
  );
}

export default AddHospital;
